import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';

const HomePage = lazy(() => import('../pages/home/page'));
const CarPage = lazy(() => import('../pages/car/page'));
const GreetingPage = lazy(() => import('../pages/greeting/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/car',
    element: <CarPage />,
  },
  {
    path: '/greeting',
    element: <GreetingPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;